import styled from '@emotion/styled';

const Th = styled.th(props => ({
  width: '36px',
}))

export default Th;
